// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signal-high[data-v-b1052cec]{color:#b97709;background:rgba(230,166,38,.12);padding:2px 5px;border-radius:4px}.signal-low[data-v-b1052cec]{color:#287dbb;background:rgba(66,153,225,.12);padding:2px 5px;border-radius:4px}\n", ""]);
// Exports
module.exports = exports;
